import React from 'react'
import propTypes from 'prop-types'

/** Material UI import section */
import { Drawer } from '@material-ui/core'
import { panelLateralStyles } from '../../../resources/styles/PanelLateralStyles'

const LateralPanel = (props) => {
	const { onClose, children, width } = props

	const classes = panelLateralStyles({ width })

	return (
		<Drawer anchor='right' open={props.open} onClose={onClose}>
			<div className={classes.drawerContent} tabIndex={0}>
				{children}
			</div>
		</Drawer>
	)
}
LateralPanel.propTypes = {
	open: propTypes.bool.isRequired
}
LateralPanel.defaultProps = {
	open: true,
	width: null // 🔹 si no se pasa, usa el default del estilo
}
export default LateralPanel
